export const breakpoints = {
    mobile: "768px",
    tablet: "1024px",
    maxWidth: "1440px",
    width4k: "3840px",
};
